export default ({
  userAddressRepository,
  maps,
  auth
}) => {
  return async (payload) => {
    const {
      onSuccess,
      onError,
      data,
      actions,
      dispatch
    } = payload

    try {
      const address = await userAddressRepository.add({
        data,
        actions,
        maps,
        dispatch,
        auth: auth()
      })

      onSuccess({address})
    } catch(e) {
      console.log(e)

      onError()
    }
  }
}
